import { CampaignAndGroupSelectorEntityToSelectType } from './state';

export enum SidebarStaticItemsIds {
    addEntity = 'addEntity',
    goToRecommendations = 'goToRecommendations',
    goToCampaigns = 'goToCampaigns',
    goToShowClients = 'goToShowClients',
    openReportsMenu = 'openReportsMenu',
    openLibraryMenu = 'openLibraryMenu',
    tools = 'tools',
    openInfoMenu = 'openInfoMenu'
}

export enum SidebarDynamicItemsIds {
    goToEdit = 'goToEdit'
}

export enum SecondLevelSidebarMenuIds {
    addEntity = 'addEntity',
    reportsMenu = 'reportsMenu',
    libraryMenu = 'libraryMenu',
    infoMenu = 'infoMenu',
    default = 'default'
}

export enum ThirdLevelSidebarMenuIds {
    addCampaign = 'addCampaign'
}

export interface SidebarItemsIds {
    static: SidebarStaticItemsIds[];
    dynamic: SidebarDynamicItemsIds[];
}

export interface SidebarState {
    expanded: boolean;
    selectedItemId?: SidebarStaticItemsIds | SidebarDynamicItemsIds;
    secondLevelMenuId?: SecondLevelSidebarMenuIds;
    thirdLevelMenuId?: ThirdLevelSidebarMenuIds;
}

export interface SidebarLinkData {
    login: string;
    ClientID: string;
    agencyLogin: string;
}

export interface SidebarLink {
    onClick?: () => void;
    text: string;
    isBeta?: boolean;
}

export interface AddEntityText {
    title: string;
    description: string;
}

export type AddEntityItem =
    | CampaignAndGroupSelectorEntityToSelectType.CAMPAIGN
    | CampaignAndGroupSelectorEntityToSelectType.GROUP
    | CampaignAndGroupSelectorEntityToSelectType.BANNER
    | CampaignAndGroupSelectorEntityToSelectType.PHRASE;
